module.exports = __webpack_public_path__ + "img/photoAlbum3.9aeaa799.jpg";